// extracted by mini-css-extract-plugin
module.exports = {"container":"QrCode_container__N9C96","text":"QrCode_text__htXD7","qr_code":"QrCode_qr_code__8__xy"};